module.exports = __webpack_public_path__ + "img/dog.3765bc62.png";